import { useForm } from 'react-hook-form';
import type { CustomDeadline } from '@biuro/shared';
import { useData, useDeleteDoc, useSaveDoc, useToast } from '../hooks.tsx';
import { DeleteButton, Sheet } from '../ui.tsx';

const SUGG: [string, CustomDeadline['repeat']][] = [
  ['Odnowienie domeny rzulty.co', 'yearly'],
  ['Odnowienie hostingu', 'yearly'],
  ['Ochrona znaku RZUŁTY', 'none'],
  ['Ubezpieczenie firmy', 'yearly'],
];

export function CustomForm({ id, onClose }: { id?: string; onClose: () => void }) {
  const { data } = useData();
  const save = useSaveDoc();
  const del = useDeleteDoc();
  const toast = useToast();
  const initial = id ? data.custom[id] : undefined;
  const { register, handleSubmit, setValue, setFocus, formState: { errors } } = useForm<CustomDeadline>({
    defaultValues: initial ?? { title: '', date: '', repeat: 'yearly', note: '' },
  });

  const submit = handleSubmit((v) => {
    save.mutate({ col: 'custom', id: id || 'c' + Date.now().toString(36), doc: { ...v, title: v.title.trim(), note: v.note?.trim() || '' } });
    toast('Zapisano termin');
    onClose();
  });

  return (
    <Sheet title={id ? 'Własny termin' : 'Nowy termin'} onClose={onClose}
      footer={<>
        {id ? <DeleteButton onConfirm={() => { del.mutate({ col: 'custom', id }); onClose(); }} /> : <span />}
        <div className="r"><button className="btn" onClick={onClose}>Anuluj</button><button className="btn pri" onClick={submit}>Zapisz</button></div>
      </>}>
      {!id && (
        <div className="sugg">
          {SUGG.map(([t, r]) => (
            <button key={t} type="button" className="btn sm" onClick={() => { setValue('title', t); setValue('repeat', r); setFocus('date'); }}>{t}</button>
          ))}
        </div>
      )}
      <form className="fgrid" onSubmit={submit}>
        <div className="fld full">
          <label htmlFor="c-title">Co</label>
          <input id="c-title" autoComplete="off" {...register('title', { required: true })} />
          {errors.title && <div className="hint err">Podaj nazwę.</div>}
        </div>
        <div className="fld">
          <label htmlFor="c-date">Data</label>
          <input id="c-date" type="date" {...register('date', { required: true })} />
          {errors.date && <div className="hint err">Podaj datę.</div>}
        </div>
        <div className="fld">
          <label htmlFor="c-rep">Powtarzaj</label>
          <select id="c-rep" {...register('repeat')}>
            <option value="none">Nie</option>
            <option value="monthly">Co miesiąc</option>
            <option value="yearly">Co roku</option>
          </select>
        </div>
        <div className="fld full">
          <label htmlFor="c-note">Notatka</label>
          <input id="c-note" autoComplete="off" {...register('note')} />
        </div>
      </form>
    </Sheet>
  );
}
